import React from 'react';
import Icon from '../icon/icon';
import { classnames } from '../../../../utils/classnames';
import './toggle.css';
import InputErrors from "../inputErrors/inputErrors";


function Toggle({className = '', checked = false, onChange = () => {}, disabled = false, ...rest}) {

    const [isChecked, setIsChecked] = React.useState(checked);
    const fileInputRef = React.useRef(null);

	const onToggle = React.useCallback(
		event => {
			const checked = event.target.checked;
			setIsChecked(checked);

			if (onChange) {
				onChange(event, checked);
			}
		},
		[onChange]
	);

	return (
		<div
			tabIndex={0}
			role="checkbox"
			aria-checked={isChecked}
			onClick={() => {fileInputRef?.current?.click()}}
			onKeyDown={(event) => {
				if (event.keyCode === 32 || event.keyCode === 13) {
					fileInputRef?.current?.click();
				}
			}}
			className={classnames('neo-toggle-container', className, {'disabled' : disabled})}
		>
			<input
				type="checkbox"
				aria-checked={isChecked}
				checked={isChecked}
				onChange={onToggle}
				disabled={disabled}
				tabIndex={-1}
				ref={fileInputRef}
				{...rest}
			/>
			<span className={classnames("neo-input-switch-slider", {'checked': isChecked})} slidercontent={""} />
			{isChecked && (
				<Icon
					name="checkSimple"
					className="neo-toggle-icon"
				/>
			)}
		</div>
	);
}

export default function ToggleLabel({ uniqueKey, errors = null, label = '', sublabel = '', required = false, inlinePosition = null, checked = false, ...rest }) {
    const fieldLabelKey = uniqueKey ? `field_${uniqueKey}` : null;
    return (
		<>
			<div className={classnames('neo-toggle-label-container', {[`${inlinePosition}_inline`] : inlinePosition})}>
				<div className='neo-toggle-label-and-sublabel'>
					<label className={classnames('neo-toggle-label', {'required': required})} for={fieldLabelKey}>
						{label}
					</label>
					<label className='neo-toggle-sublabel'>
						{sublabel}
					</label>
				</div>
				<Toggle id={fieldLabelKey} checked={checked} {...rest} />
			</div>
			{(!checked && <InputErrors errors={errors}/>)}
		</>
    )
}
